import * as React from 'react';

interface IProps {
    onShowTypingClick: () => void;
    checked: boolean;
}


export class ShowTyping extends React.Component<IProps, null> {
    render() {
        const { onShowTypingClick, checked } = this.props;
        return (
            <div className="cpg-show-password center">
                <input id="show-password" type="checkbox" onChange={onShowTypingClick} checked={checked} />
                <label htmlFor="show-password">Show typing</label>
                <img src="../../../Static/img/arr_curved-topright.png" />
            </div>
        )
    }
}